module.exports = __webpack_public_path__ + "static/media/Unlock_U_Logo.ca9822e9.png";